import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { USERNAME } from '../../constants/common';

import { useUser } from '../../context/user';

import SessionProvider from './SessionProvider';

const SessionProviderContainer = (props) => {

  const history = useNavigate();
  const location = useLocation();
  const isRedirecting = useRef(false);

  const { user, dispatchUser } = useUser();

  useEffect(() => {
    // Prevent multiple rapid redirects
    if (isRedirecting.current) {
      return;
    }

    if (!user) {
      if (!["/login", "/forgotPassword"].includes(location.pathname)) {
        isRedirecting.current = true;
        history(`/login`, { replace: true });
        // Reset the flag after a short delay
        setTimeout(() => {
          isRedirecting.current = false;
        }, 100);
        return;
      }
    } else {
      if (location.pathname === "/login") {
        isRedirecting.current = true;
        history(`/dashboard`);
        // Reset the flag after a short delay
        setTimeout(() => {
          isRedirecting.current = false;
        }, 100);
      }
    }
  }, [history, location.pathname, user, dispatchUser]);

  return <SessionProvider {...props} />;
};

export default React.memo(SessionProviderContainer);
